import { IAutoMapper } from "../../../core/automapper/interfaces";
import { ProjectAttribute } from "../project/project-config/models/project-attribute.model";

export const mapAttributesAndChase = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "AttributesAndChase")
    .forMember("measureCode", o => o.measureCode)
    .forMember("attributes", o => {
      const isArray = Array.isArray(o.attributes) && o.attributes.length > 0;
      return isArray ? automapper.mapMany("default", "ProjectAttribute", o.attributes) : [];
    });
};

export class AttributesAndChaseModel {
  readonly measureCode: string;
  readonly attributes: ProjectAttribute[];

  constructor(options: Partial<AttributesAndChaseModel>) {
    this.measureCode = options.measureCode;
    this.attributes = options.attributes;
  }
}
